import React, { useEffect } from 'react';
import { MdBrightness6 } from "react-icons/md";

function DarkModeSwitch({ mode, toggleMode }) {
    useEffect(() => {
        const savedMode = localStorage.getItem('mode');
        if (savedMode === 'dark') {
            document.body.classList.add('dark');
            document.getElementById('dark-mode-toggle').checked = true;
        }

        // Clean up
        return () => {
            document.body.classList.remove('dark');
            document.getElementById('dark-mode-toggle').checked = false;
        };
    }, []); // Run once on component mount

    const handleDarkModeToggle = () => {
        const darkModeToggle = document.getElementById('dark-mode-toggle');
        if (darkModeToggle.checked) {
            document.body.classList.add('dark');
            localStorage.setItem('mode', 'dark');
        } else {
            document.body.classList.remove('dark');
            localStorage.setItem('mode', 'light');
        }
        toggleMode(); // Call the parent component's toggleMode function
    };

    return (
        <div className="form-check form-switch float-end d-flex align-items-center">
            <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                id="dark-mode-toggle"
                onChange={handleDarkModeToggle}
                checked={mode === 'dark'} // Reflect mode state
            />
            <label className="form-check-label" htmlFor="dark-mode-toggle">
            <MdBrightness6 className="toggle" /><span className="visually-hidden">Light/Dark</span>
            </label>
        </div>
    );
}

export default DarkModeSwitch;
